import { defineStore } from "pinia";
import * as notificationService from "@/services/notificationService";

// Sino da topbar. Store próprio (não o de usuário): tem ciclo de vida seu - a
// consulta periódica começa quando o layout autenticado monta e para quando
// ele sai (logout, sessão expirada).
//
// Sem WebSocket no projeto: consulta a cada POLL_MS e sempre que a aba volta
// ao foco, que é quando a pessoa está olhando.
const POLL_MS = 60_000;

export const useNotificationStore = defineStore("notifications", {
  state: () => ({
    items: [],
    unreadCount: 0,
    isLoaded: false,
  }),

  actions: {
    applyList(data) {
      this.items = data.items;
      this.unreadCount = data.unreadCount;
      this.isLoaded = true;
    },

    async fetch() {
      try {
        const { data } = await notificationService.getNotifications();
        this.applyList(data);
      } catch {
        // Sino é secundário: uma falha de rede não vira erro na tela; a próxima
        // consulta tenta de novo.
      }
    },

    // Abrir o sino marca tudo como lido (o contador some); os itens ficam.
    async markAllRead() {
      if (!this.unreadCount) return;
      const { data } = await notificationService.markAllNotificationsRead();
      this.applyList(data);
    },

    async remove(notificationId) {
      await notificationService.deleteNotification(notificationId);
      this.items = this.items.filter((n) => n.notificationId !== notificationId);
    },

    // Apaga as lidas e as resolvidas; convite ainda sem resposta fica.
    async clear() {
      const { data } = await notificationService.clearNotifications();
      this.applyList(data);
    },

    async accept(invitationId, consent) {
      const { data } = await notificationService.acceptInvitation(invitationId, consent);
      await this.fetch();
      return data;
    },

    async decline(invitationId) {
      await notificationService.declineInvitation(invitationId);
      await this.fetch();
    },

    startPolling() {
      this.stopPolling();
      this.fetch();
      this._timer = setInterval(() => this.fetch(), POLL_MS);
      this._onVisible = () => {
        if (document.visibilityState === "visible") this.fetch();
      };
      document.addEventListener("visibilitychange", this._onVisible);
    },

    stopPolling() {
      if (this._timer) clearInterval(this._timer);
      this._timer = null;
      if (this._onVisible) document.removeEventListener("visibilitychange", this._onVisible);
      this._onVisible = null;
    },

    reset() {
      this.stopPolling();
      this.items = [];
      this.unreadCount = 0;
      this.isLoaded = false;
    },
  },
});
